import type { BubbleProps } from './features/Bubble'

export const defaultBubbleProps: BubbleProps = {
  clientId: '7fd0f09e-8bf9-4612-bd1c-98f0a4fdacbd',
  apiHost: 'http://localhost:5000/api/chat',
  autoShowDelay: undefined,
  brandColor: undefined,
  isPreview: undefined,
  netwatchBot: undefined,
  onAnswer: undefined,
  onClose: undefined,
  onEnd: undefined,
  onInit: undefined,
  onNewInputBlock: undefined,
  onOpen: undefined,
  onPreviewMessageClick: undefined,
  prefilledVariables: undefined,
  previewMessage: {
    message: '👋 Hello Netwatch is here.',
    autoShowDelay: 1000,
  },
  resultId: undefined,
  theme: {
    button: {
      backgroundColor: undefined,
      customCloseIconSrc: undefined,
      customIconSrc: undefined,
      iconColor: undefined,
      size: 'large',
    },
    chatWindow: {
      backgroundColor: undefined,
      maxHeight: undefined,
      maxWidth: undefined,
    },
    placement: undefined,
    previewMessage: {
      backgroundColor: undefined,
      closeButtonBackgroundColor: undefined,
      closeButtonIconColor: undefined,
      textColor: undefined,
    },
  },
}
